var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalbalance3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 117,
    viewBox: "0 0 240 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2007_1251)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00195312,
    width: 240,
    height: 117,
    rx: 8,
    fill: "#14170E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.65635 119.752L1.20635 100.152C-0.120731 99.6415 -1.37024 99.029 -2.54215 98.3145C-3.71407 97.5999 -4.86353 96.8342 -5.99052 96.0176L-24.2124 103.674L-41.0562 74.5801L-25.2843 62.6363C-25.3864 61.9217 -25.4374 61.2337 -25.4374 60.5722V56.4378C-25.4374 55.7722 -25.3864 55.0822 -25.2843 54.3676L-41.0562 42.4238L-24.2124 13.3301L-5.99052 20.9863C-4.86761 20.1697 -3.69365 19.404 -2.46865 18.6895C-1.24365 17.9749 -0.0186501 17.3624 1.20635 16.852L3.65635 -2.74805H37.3438L39.7938 16.852C41.1209 17.3624 42.3725 17.9749 43.5485 18.6895C44.7245 19.404 45.8719 20.1697 46.9907 20.9863L65.2126 13.3301L82.0563 42.4238L66.2845 54.3676C66.3866 55.0822 66.4376 55.7722 66.4376 56.4378V60.5661C66.4376 61.2317 66.3355 61.9217 66.1313 62.6363L81.9032 74.5801L65.0595 103.674L46.9907 96.0176C45.8678 96.8342 44.6938 97.5999 43.4688 98.3145C42.2439 99.029 41.0188 99.6415 39.7938 100.152L37.3438 119.752H3.65635ZM20.8064 79.9395C26.7272 79.9395 31.7803 77.8467 35.9657 73.6613C40.1511 69.4759 42.2439 64.4228 42.2439 58.502C42.2439 52.5811 40.1511 47.528 35.9657 43.3426C31.7803 39.1572 26.7272 37.0645 20.8064 37.0645C14.7834 37.0645 9.70377 39.1572 5.56735 43.3426C1.43093 47.528 -0.635235 52.5811 -0.631149 58.502C-0.631149 64.4228 1.43705 69.4759 5.57347 73.6613C9.70989 77.8467 14.7875 79.9395 20.8064 79.9395Z",
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.935 34.002H31.687L30.411 30.319H23.828L22.552 34.002H19.304L25.365 16.66H28.903L34.935 34.002ZM29.454 27.419L27.134 20.575L24.785 27.419H29.454ZM40.237 34.002H37.192V16.66H40.237V34.002Z",
    fill: "#10C237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.599 96.116V93.767C29.599 93.709 29.5893 93.6606 29.57 93.622C29.454 93.4093 29.28 93.1966 29.048 92.984C28.8353 92.7713 28.6613 92.665 28.526 92.665H28.497H24.814V89.794H28.497H28.526C28.6613 89.794 28.8353 89.6876 29.048 89.475C29.28 89.2623 29.454 89.0496 29.57 88.837L29.599 88.692V86.604L29.57 86.459C29.4347 86.227 29.251 86.0143 29.019 85.821C28.8063 85.6083 28.6323 85.502 28.497 85.502H25.191C25.1523 85.502 25.1137 85.5116 25.075 85.531C24.8237 85.647 24.5433 85.85 24.234 86.14C23.944 86.4106 23.7507 86.7006 23.654 87.01L20.696 86.198C20.9473 85.676 21.1793 85.2603 21.392 84.951C22.6487 83.3656 23.886 82.573 25.104 82.573H28.526C29.28 82.573 29.9567 82.7856 30.556 83.211C31.1553 83.6556 31.6773 84.1873 32.122 84.806C32.47 85.328 32.644 85.9176 32.644 86.575V88.75C32.644 89.62 32.2573 90.4416 31.484 91.215C32.2573 91.9883 32.644 92.8196 32.644 93.709V96.145C32.644 96.8023 32.47 97.392 32.122 97.914C31.9867 98.1073 31.7353 98.3876 31.368 98.755C31.02 99.1223 30.7493 99.3736 30.556 99.509C29.9567 99.9343 29.28 100.147 28.526 100.147H25.104C23.8473 100.147 22.61 99.3543 21.392 97.769C21.0247 97.2663 20.783 96.8506 20.667 96.522L23.625 95.739C24.147 96.5123 24.6207 97.0053 25.046 97.218C25.0847 97.2373 25.133 97.247 25.191 97.247H28.497C28.613 97.247 28.787 97.1406 29.019 96.928C29.251 96.7153 29.4347 96.493 29.57 96.261C29.5893 96.2223 29.599 96.174 29.599 96.116Z",
    fill: "#10C237"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2007_1251)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.539 81.5005L184.27 34.002L102 81.5005V103.71L184.27 151.208L266.539 103.71V81.5005Z",
    fill: "#10C237"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.54 81.5L184.271 128.998L102.001 81.5L184.271 34.002L266.54 81.5Z",
    fill: "#00FF38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.499 118.153L137.839 82.2837L150.825 74.7862L213.09 96.45L202.632 102.487L188.963 97.3575L177.071 104.224L185.956 112.116L175.499 118.153ZM170.578 98.5019L178.984 93.6483L164.563 88.0844C162.513 87.2688 160.462 86.4796 158.412 85.7167C156.361 84.9012 154.767 84.2699 153.627 83.8226C154.402 84.4803 155.473 85.3879 156.84 86.5454C158.252 87.6766 159.642 88.8473 161.009 90.0574L170.578 98.5019ZM215.455 95.0843L206.228 89.7571L216.138 84.0354L184.699 65.8836L174.788 71.6054L165.561 66.2782L195.634 48.9157L204.861 54.2428L194.951 59.9646L226.391 78.1163L236.301 72.3946L245.528 77.7217L215.455 95.0843Z",
    fill: "#132E19"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_2007_1251)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -98,
    cy: 59.002,
    rx: 118,
    ry: 94,
    fill: "#10C237"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.50195,
    width: 237,
    height: 114,
    rx: 6.5,
    stroke: "#10C237",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2007_1251",
    x: 84.6077,
    y: 16.6102,
    width: 199.324,
    height: 151.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.69589
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0416667 0 0 0 0 1 0 0 0 0 0.2525 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2007_1251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2007_1251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2007_1251",
    x: -287.1,
    y: -106.098,
    width: 378.2,
    height: 330.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.55,
    result: "effect1_foregroundBlur_2007_1251"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2007_1251"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.00195312,
    width: 240,
    height: 117,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalbalance3);
export default __webpack_public_path__ + "static/media/Personal balance3.777b2f80ac60f86b8de24fd9ce51ff9e.svg";
export { ForwardRef as ReactComponent };